import {IngredientUnits} from "../enums/enums";

export const expenseProductSchema = ({list, Status}) => {
    const {
        items: tagList,
        status: tagListStatus,
    } = list.tag;
    return (
        {
            name: {
                type: 'text',
                label: 'Name',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            unit: {
                type: 'select',
                label: 'Unit',
                enums: true,
                options: IngredientUnits,
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    return null;
                },
            },
            stock: {
                type: 'text',
                label: 'Stock',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!String(value).trim()) return 'Stock is required';
                    return null;
                },
            },
            status: {
                type: 'select',
                label: 'Status',
                enums: true,
                options: Status,
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    return null;
                },
            },
            tags: {
                type: 'multiselect',
                label: 'Tags',
                options: tagListStatus === "success" ? tagList : {},
                columns: {md: 12, lg: 6},
                isSearch: true,
                searchPlaceholder: 'Search "Tags"',
                validation: (value) => {
                    if (!Array.isArray(value) || value.length === 0) return 'At least one tag is required';
                    return null;
                },
            },
            description: {
                type: 'textarea',
                label: 'Description',
            },
            additionalDetails: {
                type: 'object',
                properties: {
                    isVeg: {
                        type: 'checkbox',
                        label: 'Is Veg',
                        columns: {md: 12, lg: 6},
                        validation: (value) => {
                            return null;
                        },
                    }
                }
            }
        }
    )
}
